import React, {Component, ReactElement} from 'react'
import {SessionStorageHelper} from '../../../SessionStorageHelper';
import {Nullable} from '../../../app/TypeHelpers';
import {Location} from 'react-router-dom'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage';
import {NatAsyncCallFunction, setSessionStorage} from '../../common/util/Natutil';
import NatResidentUserRepo, {ResidentUserConfirmRequest} from '../residentUser/repository/NatResidentUserRepo';
import {NatPostResidentLogin} from './repository/NatPostResidentLogin';
import {
    NatResidentLoginInfoSessionStorageHelper
} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper';
import {FIRST_LOGIN_REFERRER_ID, RESIDENT_USER_TYPE} from '../../../CodeMaster';
import NatSessionRepo from '../session/repository/NatSessionRepo';
import {NatGetServerSessionInfo} from '../session/repository/NatGetServerSessionInfo';
import {NatGetToken} from '../token/repository/NatGetToken';
import {
    NatGetRoomToResidentAuthenticationKey
} from '../roomToResident/repository/NatGetRoomToResidentAuthenticationKey';
import {DIspStepInfo} from '../common/resident/NatStepComponent';
import {Messages} from '../../../Messages';
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo';
import NatTokenRepo from '../token/repository/NatTokenRepo';
import {Data as ResidentSsoLoginInfo, NatPostResidentSsoLogin} from '../sso/repository/NatPostResidentSsoLogin';
import {BelongCondominiumInfo} from './repository/AdminUserLoginInfo';
import AdminAuthRepository from './repository/AdminAuthRepository';
import NatMenuMasterRepo from '../menuMaster/repository/NatMenuMasterRepo';
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo';
import {NatGetResidentUserAuthenticationKey} from '../residentUser/repository/NatGetResidentUserAuthenticationKey';
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody';
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError';


const KEY_SENI_TYPE = 'seniType';
const KEY_SENI_URL = 'seniUrl';
const SENI_TYPE_MYPAGE = 'seniTypeMypage';
const SENI_TYPE_CONDOMINIUM_SELECTION = 'seniTypeCondominiumSelection';
const SENI_TYPE_OTHER = 'seniTypeOther';
const FIRSTLOGINLOCATIONSTATE = 'firstLoginLocationState';
const QUERYTOKEN = 'queryToken';
const TOKEN = 'token';
const CONDOMINIUM_DATA = 'condominiumData';
const ISOWNERSHIPTRANSFER = 'isOwnershipTransfer';
const DISPSTEPINFO = 'dIspStepInfo';
const KEY_SSO_LOGIN_CONDOMINIUM_CD = 'ssoLoginCondominiumCd';
const KEY_SSO_LOGIN_RIDGE_CD = 'ssoLoginRidgeCd';
const KEY_SSO_LOGIN_ROOM_NUMBER = 'ssoLoginRoomNumber';


interface Props {
    location: Location
    residentUserRepo: NatResidentUserRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    tokenRepo: NatTokenRepo,
    adminAuthRepo: AdminAuthRepository
    menuMasterRepo: NatMenuMasterRepo
    sessionRepo: NatSessionRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
}

interface State {
    condominiumSelectDialogOpen: boolean
    belongCondominiumInfoList: BelongCondominiumInfo[]
}

interface FirstLoginLocationState {
    firstLoginReferrerId: string
    dIspStepInfo: DIspStepInfo
    policyAgreeType: string
    residentUserType: string
    authenticationKey: string
    firstLoginUserInfoInput: {
        hasekoId: string,
        parentResidentId: string,
        condominiumName: string,
        ridgeName: string,
        roomNumber: string,
        policyAgreeType: string,
        familyName: string,
        firstName: string,
        familyNameKana: string,
        firstNameKana: string,
        birthday: string,
        mailAddress: string,
        sex: string,
        accessControlDiv: string
    }
}

interface Token {
    details: {
        token: string,
        sutekiNetId: string,
        mailAddress: string,
        authenticationKey: string,
        parentResidentId: string,
        policyAgreeType: string,
        referenceId: string,
        condominiumCd: string,
        condominiumName: string,
        ridgeCd: string,
        ridgeName: string,
        roomNumber: string,
        familyName: string,
        firstName: string,
        familyNameKana: string,
        firstNameKana: string,
        flpExistFlag: string,
    },
}

class NatResidentAfterLoginCushion extends Component<Props & ResidentPagePropsSet, State> {

    seniUrl: Nullable<string>;
    seniType: Nullable<string>;
    ssoLoginCondominiumCd: Nullable<string>;
    ssoLoginRidgeCd: Nullable<string>;
    ssoLoginRoomNumber: Nullable<string>;

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props);

        this.state = {
            condominiumSelectDialogOpen: false,
            belongCondominiumInfoList: []
        }
        this.seniUrl = SessionStorageHelper.getStringItemOrNull(KEY_SENI_URL);
        this.seniType = SessionStorageHelper.getStringItemOrNull(KEY_SENI_TYPE);
        this.ssoLoginCondominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_CONDOMINIUM_CD);
        this.ssoLoginRidgeCd = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_RIDGE_CD);
        this.ssoLoginRoomNumber = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_ROOM_NUMBER);
        this.handleCloseForCondominiumSelectDialog = this.handleCloseForCondominiumSelectDialog.bind(this);
    }

    async componentDidMount(): Promise<void> {
        // サーバ側のセッション情報を取得
        const sessionInfoForLoginPage: Nullable<NatGetServerSessionInfo> = await NatAsyncCallFunction(
            this.props.residentUserRepo.getBackendSessionInfo.bind(this.props.residentUserRepo),
            this.props.navigate, this.systemErrorTransition
        )
        let loginPage = null;
        if (sessionInfoForLoginPage && sessionInfoForLoginPage.loginPage) {
            loginPage = sessionInfoForLoginPage.loginPage
        }
        // 居住者ログイン
        if ('NatResidentLogin' === loginPage) {
            // サーバ側のセッション情報を取得
            if (sessionInfoForLoginPage && sessionInfoForLoginPage.residentLoginInfo) {
                const loginInfo: NatPostResidentLogin = sessionInfoForLoginPage.residentLoginInfo
                if (loginInfo &&
                    loginInfo.role === null) {
                    NatResidentLoginInfoSessionStorageHelper.setSessionStorageUserInfo(loginInfo)
                    // 所属物件が複数の場合
                    const seniurl = sessionStorage.getItem(KEY_SENI_URL);
                    if (seniurl) {
                        setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_CONDOMINIUM_SELECTION)
                        setSessionStorage(KEY_SENI_URL, seniurl)
                        this.props.navigate('/resident/condominiumSelect',
                            {state: {seniurl: seniurl}})

                    } else {
                        setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_CONDOMINIUM_SELECTION)
                        this.props.navigate('/resident/condominiumSelect')
                    }
                } else if (loginInfo && loginInfo.role) {
                    // 所属物件が1件の場合
                    NatResidentLoginInfoSessionStorageHelper.setSessionStorage(loginInfo)
                    const seniurl = sessionStorage.getItem(KEY_SENI_URL);
                    if (seniurl) {
                        setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_OTHER)
                        setSessionStorage(KEY_SENI_URL, seniurl)
                        this.props.navigate(`${seniurl}`)
                    } else {
                        setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_MYPAGE)
                        this.props.navigate('/resident/mypage')
                    }
                }
            }
        }
        // 初回ログイン長谷工ID確認
        else if ('NatResidentFirstLoginHasekoIdConfirmPage' === loginPage) {
            try {
                // // サーバ側のセッション情報を取得
                if (sessionInfoForLoginPage && sessionInfoForLoginPage.residentFirstLoginUserInfo) {
                    const authenticationInfo: NatGetResidentUserAuthenticationKey = {
                        details: {
                            residentUserInfo: sessionInfoForLoginPage.residentFirstLoginUserInfo.residentUserInfo
                        },
                        informations: null,
                        requestError: null,
                        requestItemErrors: null
                    }
                    if (authenticationInfo.details !== null) {
                        const firstLoginLocationState: FirstLoginLocationState | null =
                            SessionStorageHelper.getObject(FIRSTLOGINLOCATIONSTATE)
                                ? SessionStorageHelper.getObject(FIRSTLOGINLOCATIONSTATE)
                                : null;
                        const queryToken = SessionStorageHelper.getStringItemOrNull(QUERYTOKEN)
                        if (firstLoginLocationState) {
                            let condominiumData: NatGetToken | NatGetRoomToResidentAuthenticationKey | null = null;
                            let step: DIspStepInfo = {};

                            if (firstLoginLocationState.residentUserType === RESIDENT_USER_TYPE.MAIN.value) {
                                const authenticationKey: string = firstLoginLocationState.authenticationKey;
                                // 物件情報取得
                                condominiumData = await NatAsyncCallFunction(
                                    this.props.roomToResidentRepo.getRoomToResidentByAuthenticationKey.bind(
                                        this.props.roomToResidentRepo, authenticationKey)
                                    , this.props.navigate, this.systemErrorTransition);
                                // STEP
                                step = {
                                    policy: true,
                                    authenticationKey: true,
                                    hasekoIdConfirm: true,
                                    userConfirm: true,
                                    complete: true,
                                }
                            } else {
                                // 物件情報取得
                                condominiumData = await NatAsyncCallFunction(
                                    this.props.tokenRepo.getToken.bind(
                                        this.props.tokenRepo,
                                        typeof queryToken === 'string' ? queryToken : ''
                                    ), this.props.navigate, this.systemErrorTransition);
                                // STEP
                                step = {
                                    policy: true,
                                    hasekoIdConfirm: true,
                                    subUserConfirm: true,
                                    complete: true,
                                }
                            }

                            if (condominiumData && condominiumData.details !== null) {
                                const birthday: string[] = authenticationInfo.details.residentUserInfo.birthday.split('/');
                                const confirmRequest: ResidentUserConfirmRequest = {
                                    familyName: authenticationInfo.details.residentUserInfo.familyName,
                                    firstName: authenticationInfo.details.residentUserInfo.firstName,
                                    familyNameKana: authenticationInfo.details.residentUserInfo.familyNameKana,
                                    firstNameKana: authenticationInfo.details.residentUserInfo.firstNameKana,
                                    birthdayYear: birthday[0],
                                    birthdayMonth: birthday[1],
                                    birthdayDay: birthday[2],
                                    sex: authenticationInfo.details.residentUserInfo.sex,
                                    password: '',
                                    wishToHasekoGroupInfos: '',
                                    sutekiNetOfNotice: '',
                                };

                                try {
                                    // 居住者ユーザ登録確認
                                    await NatAsyncCallFunction(
                                        this.props.residentUserRepo.residentUserConfirm.bind(
                                            this.props.residentUserRepo,
                                            confirmRequest), this.props.navigate, this.systemErrorTransition);
                                    // 引継ぎ情報
                                    firstLoginLocationState.firstLoginReferrerId =
                                        FIRST_LOGIN_REFERRER_ID.HASEKO_ID_CONFIRM.value;
                                    firstLoginLocationState.firstLoginUserInfoInput = {
                                        hasekoId: authenticationInfo.details.residentUserInfo.hasekoId,
                                        parentResidentId: condominiumData.details.parentResidentId,
                                        condominiumName: condominiumData.details.condominiumName,
                                        ridgeName: condominiumData.details.ridgeName,
                                        roomNumber: condominiumData.details.roomNumber,
                                        policyAgreeType: firstLoginLocationState.policyAgreeType,
                                        familyName: authenticationInfo.details.residentUserInfo.familyName,
                                        firstName: authenticationInfo.details.residentUserInfo.firstName,
                                        familyNameKana: authenticationInfo.details.residentUserInfo.familyNameKana,
                                        firstNameKana: authenticationInfo.details.residentUserInfo.firstNameKana,
                                        birthday: authenticationInfo.details.residentUserInfo.birthday,
                                        mailAddress: authenticationInfo.details.residentUserInfo.mailAddress,
                                        sex: authenticationInfo.details.residentUserInfo.sex,
                                        accessControlDiv: authenticationInfo.details.residentUserInfo.accessControlDiv
                                    };
                                    firstLoginLocationState.dIspStepInfo = step;

                                    this.props.navigate(
                                        `/resident/firstLoginUserInfoConfirm?token=${queryToken}`,
                                        {
                                            state:
                                                {firstLoginLocationState: firstLoginLocationState}
                                        },
                                    )
                                } catch (HttpError) {
                                    // 連携対象の会員情報が不足
                                    this.systemErrorTransition()
                                    return;
                                }
                            }
                        }
                    }
                }
            } catch (HttpError) {
                // 認証エラー
                const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody;
                if (errorResponseBody !== null) {
                    if (errorResponseBody.requestError !== null) {
                        this.systemErrorTransition()
                    }
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }
        // 初回ログイン長谷工IDパスワード確認
        else if ('NatResidentFirstLoginHasekoIdPasswordConfirmPage' === loginPage) {
            try {
                // サーバ側のセッション情報を取得
                if (sessionInfoForLoginPage && sessionInfoForLoginPage.residentFirstLoginUserInfo) {
                    const authenticationInfo: NatGetResidentUserAuthenticationKey = {
                        details: {
                            residentUserInfo: sessionInfoForLoginPage.residentFirstLoginUserInfo.residentUserInfo
                        },
                        informations: null,
                        requestError: null,
                        requestItemErrors: null
                    }
                    // 元画面の処理流用
                    if (authenticationInfo === null) {
                        this.systemErrorTransition()
                        return
                    }

                    if (authenticationInfo.details === null) {
                        this.systemErrorTransition()
                        return
                    }

                    try {
                        const queryToken = SessionStorageHelper.getStringItemOrNull(QUERYTOKEN)
                        const birthday: string[] = authenticationInfo.details.residentUserInfo.birthday.split('/');
                        // 居住者ユーザ登録確認
                        const confirmRequest: ResidentUserConfirmRequest = {
                            familyName: authenticationInfo.details.residentUserInfo.familyName,
                            firstName: authenticationInfo.details.residentUserInfo.firstName,
                            familyNameKana: authenticationInfo.details.residentUserInfo.familyNameKana,
                            firstNameKana: authenticationInfo.details.residentUserInfo.firstNameKana,
                            birthdayYear: birthday[0],
                            birthdayMonth: birthday[1],
                            birthdayDay: birthday[2],
                            sex: authenticationInfo.details.residentUserInfo.sex,
                            password: ``,
                            wishToHasekoGroupInfos: ``,
                        }
                        await NatAsyncCallFunction(
                            this.props.residentUserRepo.residentUserConfirm.bind(
                                this.props.residentUserRepo, confirmRequest),
                            this.props.navigate, this.systemErrorTransition);

                        // 情報をセッションから取得
                        // token
                        const token: Token | null = SessionStorageHelper.getObject(TOKEN)
                        let policyAgreeType = null
                        let parentResidentId = null
                        let mailAddress = null
                        if (token) {
                            policyAgreeType = token.details.policyAgreeType ?? ''
                            parentResidentId = token.details.parentResidentId ?? ''
                            mailAddress = token.details.mailAddress ?? ''
                        }
                        // condominiumData
                        const condominiumData: NatGetRoomToResidentAuthenticationKey | null
                            = SessionStorageHelper.getObject(CONDOMINIUM_DATA)
                        const dIspStepInfo: DIspStepInfo | null = SessionStorageHelper.getObject(DISPSTEPINFO)
                        if (condominiumData && condominiumData.details) {
                            this.props.navigate(
                                `/resident/firstLoginUserInfoConfirm?token=${queryToken}`,
                                {
                                    state:
                                        {
                                            firstLoginLocationState: {
                                                firstLoginReferrerId:
                                                FIRST_LOGIN_REFERRER_ID.HASEKO_PASSWORD_CONFIRM.value,
                                                policyAgreeType: policyAgreeType,
                                                firstLoginUserInfoInput: {
                                                    hasekoId: authenticationInfo.details.residentUserInfo.hasekoId,
                                                    parentResidentId: parentResidentId,
                                                    condominiumCd: condominiumData.details.condominiumCd,
                                                    condominiumName: condominiumData.details.condominiumName,
                                                    ridgeName: condominiumData.details.ridgeName,
                                                    roomNumber: condominiumData.details.roomNumber,
                                                    policyAgreeType: policyAgreeType,
                                                    familyName: authenticationInfo.details.residentUserInfo.familyName,
                                                    firstName: authenticationInfo.details.residentUserInfo.firstName,
                                                    familyNameKana:
                                                    authenticationInfo.details.residentUserInfo.familyNameKana,
                                                    firstNameKana:
                                                    authenticationInfo.details.residentUserInfo.firstNameKana,
                                                    birthday: authenticationInfo.details.residentUserInfo.birthday,
                                                    mailAddress: mailAddress,
                                                    sex: authenticationInfo.details.residentUserInfo.sex,
                                                    receivingAgencyCd: condominiumData.details.receivingAgencyCd,
                                                    isOwnershipTransfer:
                                                        SessionStorageHelper.getStringItemOrNull(ISOWNERSHIPTRANSFER) ?? ''
                                                },
                                                dIspStepInfo: dIspStepInfo,
                                            }
                                        },
                                },
                            )
                        }
                    } catch (HttpError) {
                        // 連携対象の会員情報が不足
                        this.systemErrorTransition()
                        return
                    }
                }
            } catch (HttpError) {
                const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
                if (errorResponseBody !== null) {
                    if (errorResponseBody.requestError !== null) {
                        this.systemErrorTransition()
                    }
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }
        // SSO
        else if ('NatResidentSsoLoginPage' === loginPage) {
            // セッションストレージを全削除
            SessionStorageHelper.removeAllItem();

            // // サーバ側のセッション情報を取得
            if (sessionInfoForLoginPage && sessionInfoForLoginPage.ssoResidentLoginInfo) {
                const ssoLoginInfo: NatPostResidentSsoLogin = {
                    details: {
                        mailAddressPc: sessionInfoForLoginPage.ssoResidentLoginInfo.mailAddressPc,
                        mailAddressMb: null,
                        userId: sessionInfoForLoginPage.ssoResidentLoginInfo.userId,
                        role: sessionInfoForLoginPage.ssoResidentLoginInfo.role,
                        authority: sessionInfoForLoginPage.ssoResidentLoginInfo.authority,
                        loginMode: sessionInfoForLoginPage.ssoResidentLoginInfo.loginMode,
                        residentUserType: sessionInfoForLoginPage.ssoResidentLoginInfo.residentUserType,
                        roleName: sessionInfoForLoginPage.ssoResidentLoginInfo.roleName,
                        familyName: sessionInfoForLoginPage.ssoResidentLoginInfo.familyName,
                        firstName: sessionInfoForLoginPage.ssoResidentLoginInfo.firstName,
                        condominiumCd: sessionInfoForLoginPage.ssoResidentLoginInfo.condominiumCd,
                        condominiumName: sessionInfoForLoginPage.ssoResidentLoginInfo.condominiumName,
                        ridgeCd: sessionInfoForLoginPage.ssoResidentLoginInfo.ridgeCd,
                        ridgeName: sessionInfoForLoginPage.ssoResidentLoginInfo.ridgeName,
                        roomNumber: sessionInfoForLoginPage.ssoResidentLoginInfo.roomNumber,
                        zipcode: sessionInfoForLoginPage.ssoResidentLoginInfo.zipcode,
                        prefectureCd: sessionInfoForLoginPage.ssoResidentLoginInfo.prefectureCd,
                        address2: sessionInfoForLoginPage.ssoResidentLoginInfo.address2,
                        address3: sessionInfoForLoginPage.ssoResidentLoginInfo.address3,
                        imagePath: sessionInfoForLoginPage.ssoResidentLoginInfo.imagePath,
                        ssoLoginUrl: sessionInfoForLoginPage.ssoResidentLoginInfo.ssoLoginUrl,
                        facilityReserveAvailability:
                        sessionInfoForLoginPage.ssoResidentLoginInfo.facilityReserveAvailability,
                        boardUserDisplay: sessionInfoForLoginPage.ssoResidentLoginInfo.boardUserDisplay,
                        assocDirectorFlag: sessionInfoForLoginPage.ssoResidentLoginInfo.assocDirectorFlag,
                        boardResidentAuthority: sessionInfoForLoginPage.ssoResidentLoginInfo.boardResidentAuthority,
                        boardAdminAuthority: sessionInfoForLoginPage.ssoResidentLoginInfo.boardAdminAuthority,
                        errorInfo: null,
                        informations: null,
                        requestError: null,
                        requestItemErrors: null
                    },
                    informations: null,
                    requestError: null,
                    requestItemErrors: null
                }
                // SSO認証OKの場合
                this.ssoLogin(ssoLoginInfo);
            }
        } else {
            this.systemErrorTransition()
        }
    }

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`,
            {
                state: {
                    message: Messages.ESYCC0015.toString(),
                    nonDisplayBackBtnFlag: SessionStorageHelper.getStringItemOrNull(ISOWNERSHIPTRANSFER) ?? ''
                }
            })
    }

    ssoLogin(ssoLoginInfo: Nullable<NatPostResidentSsoLogin>): void {
        if (ssoLoginInfo && ssoLoginInfo.details !== null) {
            // SessionStrage設定　共通保持項目
            this.setSessionStorageCommonItems(ssoLoginInfo.details);

            if (ssoLoginInfo.details.condominiumCd !== null) {
                // SessionStrage設定 物件特定時保持項目
                NatResidentLoginInfoSessionStorageHelper.setSessionStorageCondominiumInfo(ssoLoginInfo.details);
            }

            window.location.href = '/resident/loginRedirect';

        }
    }

    setSessionStorageCommonItems(residentSsoLoginInfo: ResidentSsoLoginInfo): void {
        NatResidentLoginInfoSessionStorageHelper.setSessionStorageUserInfo(residentSsoLoginInfo);

        if (residentSsoLoginInfo.condominiumCd) {
            if (this.seniUrl) {
                setSessionStorage(KEY_SENI_URL, this.seniUrl);
                setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_OTHER);
            } else {
                setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_MYPAGE);
            }
        } else {
            if (this.seniUrl) {
                setSessionStorage(KEY_SENI_URL, this.seniUrl);
            }
            setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_CONDOMINIUM_SELECTION);
        }

        if (residentSsoLoginInfo.mailAddressPc) {
            NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(
                residentSsoLoginInfo.mailAddressPc);
        } else if (residentSsoLoginInfo.mailAddressMb) {
            NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(
                residentSsoLoginInfo.mailAddressMb);
        }
    }

    handleCloseForCondominiumSelectDialog = async () => {
        try {
            await NatAsyncCallFunction(
                this.props.adminAuthRepo.logout.bind(this.props.adminAuthRepo),
                this.props.navigate, this.systemErrorTransition)
        } finally {
            this.setState({condominiumSelectDialogOpen: false})
            this.props.navigate('/admin/assoc/login')
        }
    }

    render(): Nullable<ReactElement> {
        return (
            <>
            </>
        )
    }
}

export default createResidentPage(NatResidentAfterLoginCushion)
